module.exports = {"130705001":"天泰寺街道","130705002":"皇城街道","130705003":"南关街道","130705004":"南大街街道","130705005":"大北街街道","130705006":"工业街街道","130705007":"建国街街道","130705100":"庞家堡镇","130705101":"深井镇","130705102":"崞村镇","130705103":"沙岭子镇","130705104":"洋河南镇","130705105":"大仓盖镇","130705106":"贾家营镇","130705107":"顾家营镇","130705108":"赵川镇","130705200":"河子西乡","130705201":"春光乡","130705202":"侯家庙乡","130705203":"东望山乡","130705204":"李家堡乡","130705205":"王家湾乡","130705206":"塔儿村乡","130705207":"江家屯乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130705.json
// module id = 162
// module chunks = 0